export const DEFAULT_ACCOUNT_TIMEZONE = 'America/Sao_Paulo';
